import { QuestionMethods } from '../questionMethods.types';
import {
	MatrixGivenAnswer,
	RenderedMatrixQuestion,
} from './matrixMethods.types';

export const isMatrixAnswered: QuestionMethods<
	RenderedMatrixQuestion,
	MatrixGivenAnswer
>['isAnswered'] = ({ question, givenAnswers }) => {
	const givenAnswer = givenAnswers.matrix.get(question.id);
	if (givenAnswer == null) return false;

	// An empty rows array indicates the user has explicitly answered "no answer"
	if (givenAnswer.rows.length === 0) return true;

	const columnOptions = question.columns.map((col) => col.id);

	return question.rows.every((row) =>
		givenAnswer.rows.some(
			({ columnId, rowId }) =>
				row.id === rowId && columnOptions.includes(columnId),
		),
	);
};
